import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type Theme = 'light' | 'dark' | 'system'
type ColorScheme = 'blue' | 'purple' | 'green' | 'orange' | 'pink'

interface ThemeState {
  theme: Theme
  colorScheme: ColorScheme
  fontSize: 'small' | 'medium' | 'large'
  language: 'tr' | 'en'
}

const initialState: ThemeState = {
  theme: 'light',
  colorScheme: 'blue',
  fontSize: 'medium',
  language: 'tr',
}

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setTheme: (state, action: PayloadAction<Theme>) => {
      state.theme = action.payload
    },
    setColorScheme: (state, action: PayloadAction<ColorScheme>) => {
      state.colorScheme = action.payload
    },

    setFontSize: (state, action: PayloadAction<'small' | 'medium' | 'large'>) => {
      state.fontSize = action.payload
    },
    setLanguage: (state, action: PayloadAction<'tr' | 'en'>) => {
      state.language = action.payload
    },
    toggleTheme: (state) => {
      state.theme = state.theme === 'light' ? 'dark' : 'light'
    },
    resetTheme: (state) => {
      return initialState
    },
  },
})

export const {
  setTheme,
  setColorScheme,
  setFontSize,
  setLanguage,
  toggleTheme,
  resetTheme,
} = themeSlice.actions

export default themeSlice.reducer